import i18n from 'i18next'

export default class Product {
  constructor (variants = []) {
    this.variants = variants

    this.initialize()
  }

  initialize () {
    if (this.variants.length < 1) {
      return
    }

    this.addWording()
    this.getAvailableVariants()
  }

  getAvailableVariants () {
    this.variants = this.variants.filter(v => (v.inventory_quantity > 1 || v.inventory_policy === 'continue'))
  }

  addWording () {
    let translationKey, translation, variantWordingCategories, attributes, wording
    this.variants = this.variants.map(variant => {
      wording = {}
      translationKey = variant?.sku?.replace(/\.(PE.)*T[0-9]|\.|-/g, '')
      attributes = i18n.t('productInfos:' + translationKey, { returnObjects: true })
      translationKey = attributes === translationKey ? variant.product_category : translationKey
      attributes = i18n.t('productInfos:' + translationKey, { returnObjects: true })
      variantWordingCategories = attributes && attributes !== translationKey ? Object.keys(attributes) : []
      variantWordingCategories.forEach(title => {
        translation = i18n.t('productInfos:' + translationKey + ':' + title, { returnObjects: true })
        wording[title] = title === 'discount_price' ? parseFloat(translation) : translation
      })
      return Object.assign(variant, wording)
    })
  }
}
